import type { Action } from 'redux';
import type { ConversionValueTemplateOption } from '../../../../../../shared/types/skadNetwork.types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const GetMappingTemplatesOptions = new ReduxAsyncAction<
  'GET_MAPPING_TEMPLATES_OPTIONS',
  void,
  ConversionValueTemplateOption[]
>('GET_MAPPING_TEMPLATES_OPTIONS');

GetMappingTemplatesOptions.registerRequest(async () => {
  try {
    const response = await dash_api.get<ConversionValueTemplateOption[]>('/v1/skadnetworkv2/templates/titles');

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get mapping templates. Please try again.', 'error');

    throw error;
  }
});

export const GET_MAPPING_TEMPLATES_OPTIONS = GetMappingTemplatesOptions.actionNamespaceConstants;

export const getMappingTemplatesOptions = GetMappingTemplatesOptions.request;

export type GetMappingTemplatesOptionsResponseAction = Action<typeof GET_MAPPING_TEMPLATES_OPTIONS.response> & {
  data: ConversionValueTemplateOption[];
};
